<template>
    <div class="landing-page">
        <div class="darken">
            <div class="brand-hero-content">
                <h1>Creative Web Ahead.</h1>
                <!-- <hr class="short">
                <p>
                    Web Development
                </p> -->
            </div>
            <section id="main-footer">
                <div class="row">
                    <div class="col-10 mx-auto">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-6 col-lg-3">
                                <h6>About Us</h6>
                                <p>Sekvoia is an innovative digital agency with a vast experience in creative web solutions and office based in Warsaw, Poland.</p>
                                <p>
                                    NIP: PL9482522539<br> REGON: 363470440
                                </p>
                            </div>
                            <div class="col-12 col-md-6 col-lg-3">
                                <h6>Contact</h6>
                                <p>
                                    Tomasz Zaborski<br> contact@sekvoia.co
                                    <br> +48 518 523 478<br>
                                    <i class="fab fa-skype"></i> tom.zaborski
                                </p>
                                <p>Avaiable from 9AM to 6PM</p>
                            </div>
                            <div class="col-12 col-md-12 col-lg-3">
                                <h6>Location</h6>
                                <Map></Map>
                                <p>ul. Tadeusza Borowskiego 2/320 <br>03-475 Warsaw, Poland</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "landing",
  components: {}
};
</script>
<style lang="scss" scoped>
section#main-footer {
  position: absolute;
  width: 100%;
  overflow: hidden;
  bottom: 0;
  left: 0;
  background: none;
}
.logo {
  position: absolute;
  left: 3rem;
  top: 2rem;
  span {
    color: #fff;
    font-weight: 600;
    font-size: 1.75rem;
    font-family: "Montserrat", sans-serif;
    &.dot {
      color: #92ce11;
    }
  }
}
.landing-pages {
  background: url(/bg-hero.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 20;
  .darken {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.55);
  }

  .brand-hero-content {
    padding: 12rem 5rem 0;
    text-align: center;
    h1 {
      font-size: 90px;
      margin-bottom: 1rem;
      margin-left: -7px;
    }
    hr.short {
      background: #fff;
      height: 2px;
      width: 120px;
      display: inline-block;
    }
    p {
      font-family: "Lato", sans-serif;
      font-size: 22px;
      font-weight: 300;
      text-align: center;
    }
  }
}

@media (max-width: 768px) {
    section#main-footer {
        position: relative;
        background: #0c0c0c;
    }
}
</style>
